<template>
  <v-app class="app-general">
    <v-container fluid>
      <!--      Row imagen Area54-->
      <v-row justify="center" style="margin-top: 90px;">
        <v-col align="center">
          <v-img
              src="@/assets/Logo_Area_Completo.png"
              max-width="586px"
          ></v-img>
        </v-col>
      </v-row>
      <!--      Row caja buscador-->
      <v-row justify="center">
        <v-col align="center" cols="12" md="6">

          <v-text-field
              class="text-h6"
              label="Ingrese su código de seguimiento"
              placeholder="Ingrese su código de seguimiento"
              prepend-inner-icon="fas fa-search"
              filled
              rounded
              solo
              color="black"
              v-model="comprobante"
              @keydown="error=''"
              @keypress.enter="clickEnBuscar()"
              ref="guia"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <!--      Row button buscador-->
      <v-row justify="center">
        <v-col align="center">
          <v-tooltip
              v-model="showTooltip"
              color="white"
              top>
            <template v-slot:activator="{ on }">
              <v-btn
                  large
                  elevation="10"
                  rounded
                  color="#25ABE3"
                  @click="clickEnBuscar()"
              >
                <span>Buscar</span>
              </v-btn>
            </template>
            <span class="text-justify">
              <b class="red--text ">Error :</b>
                <b class="black--text"> ingrese un número válido</b>
            </span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-row v-if="error.length>0">
        <v-col>
          <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :top="snackbar.position === 'top'">
            <v-layout align-center pr-4>
              <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
              <v-layout column>
                <div>
                  <strong>{{ snackbar.title }}</strong>
                </div>
                <div>{{ snackbar.text }}</div>
              </v-layout>
            </v-layout>
            <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-snackbar>
        </v-col>
      </v-row>


    </v-container>
  </v-app>
</template>

<script>

import guias from '../store/guias'
import VueStepper from "../components/VueStepper";

export default {
  name: 'Guia',
  components: {VueStepper},
  data() {
    return {
      comprobante: '',
      pasoStepper: 0,
      error: '',
      guiaActual: {},
      showTooltip: false,
      snackbar: {
        color: "warning",
        icon: "warning",
        mode: "multi-line",
        position: "bottom",
        timeout: 7000,
        title: "",
        text: "You probably shouldn't have seen that, oops.",
        visible: true
      },

    }
  },

  methods: {
    async clickEnBuscar() {
      if (this.comprobante) {
        try {
          const {Comprobante : guia} = await guias.getByComprobante(this.comprobante)
          console.log(guia)
          await this.$router.push({ name: 'Tracking', params: { guia }  })
          // await this.$router.push({ path: `/tracking/${data.Comprobante}` })
        } catch (error) {
          console.log("Error", error);
          this.error = error
          this.snackbar.text = error
          this.guiaActual = {}
          this.enfocarNumeroDeGuia()
        }
      } else {
        this.showTooltip = !this.showTooltip
        this.guiaActual = {}
      }
    },
    enfocarNumeroDeGuia() {
      this.comprobante = ''
      this.showTooltip = false
      this.$nextTick(() => {
        this.$refs.guia.focus()
      })
    }
  },

  mounted() {
    const guia = this.$route.params.guia
    console.log("Guia en ruta", guia);
    if (typeof guia != "undefined") {
      this.comprobante = guia
    }
    this.enfocarNumeroDeGuia()
  }
}
</script>
<style scoped>
.v-text-field {
  font-size: 2em;
}
.app-general {
  background: rgb(158, 158, 158);
  background: linear-gradient(180deg, rgba(158, 158, 158, 1) 10%, rgba(218, 218, 218, 1) 45%, rgba(158, 158, 158, 1) 90%);
}
</style>
